import LocalizedStrings from "react-localization";

export const creativeAnalysisFiltersStrings = new LocalizedStrings({
  en: {
    status: "Statuses",
    validated: "Validated",
    rejected: "Rejected",
    productCreated: "Waiting, product created",
    productRequested: "Waiting, product requested",
    id: "ID",
    creativeId: "Creative ID",
    asin: "ASIN",
    taxonomy: "Taxonomy",
    product: "Product",
    advertiser: "Advertiser",
    productId: "Product ID",
    advertiserId: "Advertiser ID",
    adName: "Ad Name",
    adPaid: "Ad Paid",
    startDate: "Start date",
    endDate: "End date",
    keyword: "Keyword",
    sponsorType: "Sponsor Type",
    all: "All",
    brand: "Brand",
    boutique: "Boutique",
    search: "Search",
  },
  fr: {
    status: "Statuts",
    validated: "Validated",
    rejected: "Rejected",
    productCreated: "Waiting, product created",
    productRequested: "Waiting, product requested",
    id: "ID",
    creativeId: "Creative ID",
    asin: "ASIN",
    taxonomy: "Taxonomy",
    product: "Produit",
    advertiser: "Annonceur",
    productId: "ID produit",
    advertiserId: "ID annonceur",
    adName: "Ad Name",
    adPaid: "Ad Paid",
    startDate: "Date de début",
    endDate: "Date de fin",
    keyword: "Keyword",
    sponsorType: "Type de sponsor",
    all: "Tout",
    brand: "Brand",
    boutique: "Boutique",
    search: "Recherche",
  },
});
